import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { Action } from '@ngrx/store';
import { Apollo } from 'apollo-angular';

import * as listingsActions from '@listings/store/actions/listings.actions';
import * as commentsActions from '@comments/store/actions/comments.actions';
import { getListingIds, getViewIds } from './helpers/view-count.helper';
import * as viewCountsConstants from 'app/modules/entity-views/constants/view-counts-graphql.constants';

@Injectable({ providedIn: 'root' })
export class EntityViewsApiService {
    constructor(private readonly apollo: Apollo) { }

    public getUnviewedCounts(): Observable<Action> {
        return this.apollo.query({ query: viewCountsConstants.GET_VIEW_COUNTS, fetchPolicy: 'no-cache' }).pipe(
            switchMap((response) => [
                listingsActions.setUnviewedListings({ listingHashcodes: getListingIds(response.data.unviewedEntities.activities) }),
                commentsActions.setUnviewedComments({ commentIds: getViewIds(response.data.unviewedEntities.comments) })
            ])
        );
    }
}
